import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Logo from '../assest/images/37a39cb7092d94d7297953ad09f2dee5.png';
import { PiPhoneCallBold } from "react-icons/pi";
import { AiOutlineUserAdd, AiOutlineLogin } from "react-icons/ai";

const pages = [
    { name: 'Home', path: '/' },
    { name: 'Patients', path: '/patientLogin' },
    { name: 'Doctors', path: '/doctorspage' },
    { name: 'Pharmacy', path: '/pharmacy' },
    { name: 'Staff', path: '/StaffLogin' }
];

function Header() {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [profilePath, setProfilePath] = useState(null);

    // Detect user role from localStorage and set profile path
    useEffect(() => {
        if (localStorage.getItem('adminToken')) {
            setProfilePath('/admin');
        } else if (localStorage.getItem('token')) {
            setProfilePath('/doctorspage');
        } else if (localStorage.getItem('patientAuthToken')) {
            setProfilePath('/patientLogin');
        } else if (localStorage.getItem('staffAuthToken')) {
            setProfilePath('/StaffLogin');
        }
    }, []);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <div>
            <AppBar position="static" sx={{ backgroundColor: '#fff', padding: "6px" }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Link to="/">
                            <img src={Logo} alt="Logo" width={70} className="mr-11 cursor-pointer" />
                        </Link>

                        {/* Mobile Menu */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                onClick={handleOpenNavMenu}
                                color="black"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElNav}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{ display: { xs: 'block', md: 'none' } }}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                                        <Link to={page.path} style={{ textDecoration: 'none', color: '#000' }}>
                                            <Typography sx={{ textAlign: 'center', textTransform: "capitalize" }}>
                                                <span className="text-[18px] font-[poppins] text-slate-600">{page.name}</span>
                                            </Typography>
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        {/* Desktop Menu */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                <Link key={page.name} to={page.path} style={{ textDecoration: 'none' }}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'black', display: 'block', fontWeight: '500', textTransform: "capitalize" }}
                                    >
                                        <span className="text-[18px] font-[poppins] text-slate-600">{page.name}</span>
                                    </Button>
                                </Link>
                            ))}
                        </Box>

                        {/* Right-side buttons */}
                        <div className="flex items-center justify-between gap-2">
                            {!profilePath ? (
                                <>
                                    <button className='bg-green outline outline-slate-500 xl:flex lg:flex md:flex items-center justify-between text-[18px] rounded-md px-2 py-1'>
                                        <AiOutlineUserAdd className='mx-1 sm:hidden xsm:hidden' />
                                        <Link to="/register">Register</Link>
                                    </button>
                                    <button className='outline text-slate-600 outline-slate-500 flex items-center justify-between text-[18px] rounded-md px-2 py-1'>
                                        <AiOutlineLogin className='mx-1 sm:hidden xsm:hidden' />
                                        <Link to="/signin">LogIn</Link>
                                    </button>
                                </>
                            ) : (
                                <div className='flex gap-3 items-center justify-center'>
                                    <Link to={profilePath}>
                                        <button className='bg-green outline outline-slate-500 xl:flex lg:flex md:flex items-center justify-between text-[18px] rounded-md px-2 py-1'>
                                            Profile
                                        </button>
                                    </Link>

                                    <button
                                        onClick={() => {
                                            localStorage.clear();
                                            window.location.reload(); // Refresh the page
                                        }}
                                        className='bg-red outline outline-slate-500 xl:flex lg:flex md:flex items-center justify-between text-[18px] rounded-md px-2 py-1'
                                    >
                                        Logout
                                    </button>
                                </div>
                            )}
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* Secondary Nav Section */}
            <div className="w-[100%] xl:flex lg:flex md:flex sm:grid xsm:grid xl:items-center lg:items-center md:items-center sm:items-start xsm:items-start xl:justify-between lg:justify-between md:justify-between sm:justify-start xsm:justify-start bg-green p-2">
                <div className="p-2">
                    <h1 className='xl:text-[40px] lg:text-[40px] md:text-[38px] sm:text-[34px] xsm:text-[32px] font-bold tracking-wide uppercase text-fontDark'>
                        Amarasinghe <span className='text-white'>medicare</span>
                    </h1>
                </div>

                <div className="p-2">
                    <h1 className='flex text-start items-center xl:text-[40px] lg:text-[40px] md:text-[38px] sm:text-[34px] xsm:text-[34px] font-bold tracking-wide uppercase text-gray-800'>
                        <PiPhoneCallBold className="mr-2" />
                        <span className='text-white'>036 2259 545</span>
                    </h1>
                </div>
            </div>
        </div>
    );
}

export default Header;
